import type { FunctionComponent } from 'react';
import { Inline } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { IconName } from '../../../../app-kit/components/PropertyFeatures/types';
import { PropertyFeatureIcon } from '../../../../app-kit/components/PropertyFeatures/subcomponents/PropertyFeatureIcon';

export interface Feature {
  iconName: IconName;
  title: string;
  valueWithUnit?: string | null;
}

const ValueWithUnit = styled.span`
  font-weight: 600;
`;
const StyledTitle = styled.span``;

const PropertyFeatureContainer = styled(Inline)``;

export const Feature: FunctionComponent<Feature> = ({ iconName, title, valueWithUnit }) => {
  return (
    <PropertyFeatureContainer grow={false} gap="twoExtraSmall" title={title}>
      <PropertyFeatureIcon iconName={iconName} title={title} />
      {valueWithUnit ? (
        <StyledTitle>
          {title}: <ValueWithUnit>{valueWithUnit}</ValueWithUnit>
        </StyledTitle>
      ) : (
        <StyledTitle>{title}</StyledTitle>
      )}
    </PropertyFeatureContainer>
  );
};
